import { useEffect } from 'react';

import { CartLogin } from '../CartLogin/CartLogin';
import styles from './CartDetails.module.scss';

import { useAuth } from '@/app/providers/AuthContext';
import { loyaltyStore } from '@/entities/loyalty/store/loyaltyStore';
import { restaurantStore } from '@/entities/restaurant/store/restaurantStore';
import { observer } from '@/shared/lib/signal/observer';
import { Icon } from '@/shared/ui-kit/Icon';

export const CartDetails = observer(() => {
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (isLoggedIn && restaurantStore.current.value?.id) {
      loyaltyStore.fetchBalance(restaurantStore.current.value.id);
    }
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return (
      <div className={styles.container}>
        <div className={styles.infoText}>
          <h1 className={styles.title}>
            Персональная скидка{' '}
            <Icon name="outlinedPercentageCircle" width={20} height={20} />
          </h1>
          <h2 className={styles.info}>
            Вы можете накопить баллы за данный заказ, зарегистрировавшись на
            кассе
          </h2>
        </div>
        <CartLogin />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.infoText}>
        <h1 className={styles.title}>
          У вас {loyaltyStore.balance.value} баллов{' '}
          <Icon name="outlinedPercentageCircle" width={20} height={20} />
        </h1>
        <h2 className={styles.info}>
          Вы можете накопить баллы за данный заказ или использовать имеющиеся
          баллы для полной или частичной оплаты на кассе
        </h2>
      </div>
    </div>
  );
});
